import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType"
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes"
import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType"

const initState = {
    groupMember: ''
}

export const groupMembersData = {
    name: "Group Members Form",
    initialState: initState,
    section: [
        {
            sectionId: 'groupMembers',
            title: "Group Members Form",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-6 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "groupMember",
                    label: "Group Member",
                    Field_Name: "Member",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "groupMember",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Member",
                        allowSpace: true,
                        options: [],
                        isMultiSelect: true
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-6 validation-text-model",
                    },
                }
            ]
        }
    ]
}

export const GroupMembersGridConfig = {
    columns: [
        {
            name: "Member Name",
            fieldName: "userName",
            allowShort: false,
            colStyle: {
                width: "90%",
                textAlign: "center",
            },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            colStyle: {
                width: "10%",
                textAlign: "center",
            },
            defaultAction: {
                allowDelete: true,
            },
        },
    ],
}